import type { DashStyleValue, SeriesLineOptions } from "highcharts";

import type {
    AiTrackerReportsBrandOverviewBrandVisibilityCompareResponse,
    AiTrackerReportsBrandOverviewBrandVisibilityCompareOvertimeResponse,
    AiTrackerReportsBrandOverviewTopicCompareData,
    AiTrackerReportsBrandOverviewTopicOvertimeData,
    AiTrackerReportsBrandOverviewBrandCompareData,
} from "@similarweb/pro-api-client";

export enum EViewMode {
    Visibility = "visibility",
    Sentiment = "sentiment",
    VisibilityOvertime = "visibilityOvertime",
}

export type SeriesItem = Required<Pick<SeriesLineOptions, "id" | "name" | "visible">> & {
    color: string;
    data: number[][];
    total: number;
    dashStyle?: DashStyleValue;
    isCoreAverage?: boolean;
    isDisabled?: boolean;
};

export type SeriesData = Record<string, Array<SeriesItem>>;

export interface IViewModeData {
    displayNameKey: string;
    displayValueFilter: (value: number) => string;
    yAxis: {
        formatter: (value: number) => string;
        dataRange?: {
            min: number;
            max: number;
        };
        tickInterval?: number;
    };
}

export type IModelComparisonTopic = AiTrackerReportsBrandOverviewTopicCompareData;
export type IModelComparisonBrand = AiTrackerReportsBrandOverviewBrandCompareData & {
    isMyBrand?: boolean;
};

export type ITopicOvertimeData = AiTrackerReportsBrandOverviewTopicOvertimeData;
export type IModelComparisonResponse = AiTrackerReportsBrandOverviewBrandVisibilityCompareResponse;
export type IModelComparisonOvertimeResponse = AiTrackerReportsBrandOverviewBrandVisibilityCompareOvertimeResponse;
